import styled from "styled-components";

export const StyledHome = styled.div`
  padding: 120px 0px 40px 70px;
  display: flex;
  flex-direction: column;
`;

export const TableContainer = styled.div`
  max-height: calc(100vh - 200px);
  overflow-y: auto;
  border: 1px solid rgb(220, 220, 251);
  border-radius: 4px;
`;

export const MainSection = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 905px;
`;

export const RightNav = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 175px;
`;

export const Table = styled.table`
  font-weight: 400;
  letter-spacing: 0.39px;
  border-collapse: separate;
  border-spacing: 0px;
  width: 100%;

  thead {
    position: sticky;
    top: 0;
    z-index: 1;
  }

  th {
    min-width: 120px;
    height: 40px;
    box-sizing: border-box;
    background-color: #eaeaf8;
    color: #2a2a3d;
    padding: 0px 16px;
    font-size: 10px;
    font-weight: 700;
    text-align: left;

    :not(:last-child) {
      border-right: 1px solid #f5f5fb;
    }

    div {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  td {
    min-width: 120px;
    padding: 0px 16px;
    height: 40px;
    box-sizing: border-box;
    color: #212530;
    padding: 0px 16px;
    font-size: 11px;
    letter-spacing: 0.39px;
    border-top: 1px solid #f5f5fb;


    white-space: nowrap;
border-bottom: 1px solid rgb(220, 220, 251);
    :not(:last-child) {

      border-right: 1px solid rgb(220, 220, 251);
    }

    div {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
`;

export const TabStrip = styled.div`
  display: flex;
  border-bottom: 1px solid #d0d4dc;
  margin-bottom: 12px;
`;

export const TabButton = styled.button<{ active?: boolean }>`
  background: none;
  border: none;
  border-bottom: 2px solid ${p => (p.active ? "#212530" : "transparent")};
  color: ${p => (p.active ? "#212530" : "#6b7280")};
  cursor: pointer;
  font: inherit;
  padding: 12px 20px;
`;
